/* eslint-disable react/no-danger */
/* eslint-disable no-tabs */
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar, Box, IconButton, Toolbar, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Link, Tooltip
} from '@material-ui/core';
// import ControlPointIcon from '@material-ui/icons/ControlPoint';
import { experimentalStyled } from '@material-ui/core/styles';
import AuthContext from '../../contexts/JWTContext';
import MenuIcon from '../../icons/Menu';
import AccountPopover from './AccountPopover';
import ContentSearch from './ContentSearch';
import LogoLight from './LogoLight';
import NotificationsPopover from './NotificationsPopover';
import CreateOrderForm from '../../components/buyer/order/CreateOrderForm';
import ExchangeRate from '../../components/common/ExchangeRate';
import CachedIcon from '@material-ui/icons/Cached';
import SendIcon from '@material-ui/icons/Send';
import constants from '../../utils/constants';
import helpers from '../../utils/helpers';
import ThemeButton from '../../components/common/ThemeButton';

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === 'light' && {
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    color: theme.palette.primary.contrastText
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none'
  }),
  zIndex: theme.zIndex.drawer + 100
}));

const DashboardNavbar = (props) => {
  const { onSidebarMobileOpen, ...other } = props;
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <AuthContext.Consumer>
        {
          ({ role, user }) => (
            <DashboardNavbarRoot
              {...other}
              className="tp-header__wrapper"
            >
              <Toolbar
                sx={{ minHeight: 64 }}
                className="tp-toolbar"
              >
                <IconButton
                  color="inherit"
                  onClick={onSidebarMobileOpen}
                  sx={{
                    display: {
                      lg: 'none'
                    }
                  }}
                >
                  <MenuIcon fontSize="small" />
                </IconButton>
                <RouterLink to="/">
                  <LogoLight
                    sx={{
                      display: {
                        lg: 'inline',
                        xs: 'none'
                      },
                      height: 37,
                      width: 200
                    }}
                  />
                </RouterLink>
                <Box
                  className="tp-user-type__wrapper"
                  sx={{
                    flexGrow: 2,
                    ml: 2
                  }}
                >
                  <Typography
                    color="textSecondary"
                    variant="body2"
                    className="tp-user-type-p"
                  >
                    <Link
                      color="primary"
                      component={RouterLink}
                      to="/change"
                      className="tp-user-type"
                    >
                      <CachedIcon />
                      {role === constants.role.buyer ? 'Firma' : 'Tedarikçi'}
                    </Link>
                  </Typography>
                </Box>
                <Box sx={{
                  ml: 1,
                  flexGrow: 2,
                  display: {
                    xs: 'none',
                    sm: 'block',
                  }
                }}
                >
                  <ContentSearch />
                </Box>
                <Box
                  sx={{
                    ml: 2,
                  }}
                >
                  <ExchangeRate />
                </Box>
                <Box
                  sx={{
                    ml: 2
                  }}
                >
                  <Tooltip
                    title="Davet linkini diğer firmalar ile paylaşın, hemen teklifleri toplayın."
                    enterDelay={800}
                    leaveDelay={200}
                  >
                    <Button
                      type="button"
                      variant="outlined"
                      className="tp-btn-invite"
                      endIcon={<SendIcon />}
                      size="small"
                      onClick={() => { helpers.copyInviteLink(user?.refCode); }}
                    >
                      Davet Et
                    </Button>
                  </Tooltip>
                </Box>
                {/* <Box sx={{ ml: 1 }}>
                  <Tooltip title="Yeni İhale Oluştur">
                    <IconButton
                      color="inherit"
                      onClick={() => setModalOpen(true)}
                    >
                      <ControlPointIcon />
                    </IconButton>
                  </Tooltip>
                </Box> */}
                <Box sx={{ ml: 1 }}>
                  <ThemeButton />
                </Box>
                <Box sx={{ ml: 1 }}>
                  <NotificationsPopover />
                </Box>
                <Box sx={{ ml: 2 }}>
                  <AccountPopover />
                </Box>
              </Toolbar>
            </DashboardNavbarRoot>
          )
        }
      </AuthContext.Consumer>

      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="xl"
      >
        <DialogTitle>Yeni İhale Oluştur</DialogTitle>
        <DialogContent className="tp-create-order__page">
          <CreateOrderForm />
        </DialogContent>
        <DialogActions>
          <Button
            type="button"
            color="primary"
            onClick={() => setModalOpen(false)}
            variant="contained"
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func
};

export default DashboardNavbar;
